export const userVariables = [
  { label: "Utilisateur", value: "user.identity" },
  { label: "Téléphone utilisateur", value: "user.phone" },
  { label: "Poste utilisateur", value: "user.position" },
];
